import { useMutation } from '@tanstack/react-query';
import { useServiceToken } from '@/auth/index';
import { useAppConfigContext } from '@/context/AppConfig';
import { RecordSearch } from '@/reports/tuxedo/interfaces';
import { request } from '@/utils/requestHelpers';
import { Lead } from './interfaces';

export class Monocle {
  public static async postLead(
    lead: { lead: Lead; record_search: RecordSearch },
    token: string
  ) {
    return await request('/mcl/leads', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(lead),
    });
  }
}

export function useMonocle() {
  const { logError } = useAppConfigContext();

  const { data: tokenData } = useServiceToken('monocle');

  const createLead = useMutation({
    mutationFn: ({
      postData,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onSuccess,
    }: {
      postData: { lead: Lead; record_search: RecordSearch };
      onSuccess?: () => void;
    }) => {
      return Monocle.postLead(postData, tokenData?.token);
    },

    onSuccess: (data, { onSuccess }) => {
      onSuccess && onSuccess();
    },
    onError: (error) => {
      logError('Error posting user profile', error as Error);
    },
  });

  return {
    createLead,
  };
}
